export const ADD_ATTRIBUTE = "ADD_ATTRIBUTE_TO_RETRIEVE";
export const REMOVE_ATTRIBUTE = "REMOVE_ATTRIBUTE_TO_RETRIEVE";
export const SET_ATTRIBUTES = "SET_ATTRIBUTES_TO_RETRIEVE";
export const UPDATE_ATTRIBUTE = "UPDATE_ATTRIBUTE_TO_RETRIEVE";

export function addAttributeToRetrieve(attributeToRetrieve) {
    return dispatch => dispatch({
        type: ADD_ATTRIBUTE,
        attributeToRetrieve
    });
}

export function removeAttributeToRetrieve(attributeToRetrieve) {
    return dispatch => dispatch({
        type: REMOVE_ATTRIBUTE,
        attributeToRetrieve
    });
}

export function setAttributesToRetrieve(attributesToRetrieve) {
    return dispatch => dispatch({
        type: SET_ATTRIBUTES,
        attributesToRetrieve
    });
}

export function updateAttributeToRetrieve(name, attribute, value) {
    return dispatch => dispatch({
        type: UPDATE_ATTRIBUTE,
        name,
        attribute,
        value
    });
}